import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import Home from "./pages/Home";
import Platform from "./pages/Platform";
import Products from "./pages/Products";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Vendors from "./pages/Vendors";
import Digital from "./pages/Digital";
import Execution from "./pages/Execution";
import ComingSoon from "./pages/ComingSoon";
import Login from "./pages/Login";
import MyEnquiries from "./pages/MyEnquiries";
import Applications from "./pages/Applications";

function AppInner() {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleCategorySelect = (selection) => {
    setSelectedCategory(selection);
    navigate("/products");
  };

  return (
    <>
      <Navbar onCategorySelect={handleCategorySelect} />
      <CartDrawer />
      <Routes>
        <Route path="/"             element={<Home />} />
        <Route path="/platform"     element={<Platform />} />
        <Route path="/products"     element={<Products preSelected={selectedCategory} />} />
        <Route path="/services"     element={<Services />} />
        <Route path="/contact"      element={<Contact />} />
        <Route path="/vendors"      element={<Vendors />} />
        <Route path="/digital"      element={<Digital />} />
        <Route path="/execution"    element={<Execution />} />
        <Route path="/login"        element={<Login />} />
        <Route path="/enquiries"    element={<MyEnquiries />} />
        <Route path="/applications" element={<Applications />} />
        <Route path="/recycling"    element={<ComingSoon title="Recycling" />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <CartProvider>
        <AppInner />
      </CartProvider>
    </Router>
  );
}

export default App;